<template>
  <div id="app">
    <div class="context">
      <router-view :key="this.$route.fullPath"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style lang="scss">
  @import "assets/styles/main";
</style>
